import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

let routes = [
  {
    path: "/relatorios/envios-whatsapp",
    component: (resolve) => require(["./app/WhatsappReport.vue"], resolve),
    name: "WhatsappReport",
    meta: { title: "Envios WhatsApp", can: ["SuperAdmin", "Admin", "Atendente"] },
  },
  {
    path: "/",
    component: (resolve) => require(["./app/Home.vue"], resolve),
    name: "Home",
    meta: { title: "Home" },
  },
  {
    path: "/usuarios/pag=:page?/filtro=:filter?",
    component: (resolve) => require(["./app/Usuarios/Usuarios.vue"], resolve),
    name: "Usuarios",
    meta: { title: "Usuários" }, // , can: 'SuperAdmin' <-- aqui define a permissão
  },
  {
    path: "/usuario/:id/editar",
    component: (resolve) =>
      require(["./app/Usuarios/EditarUsuario.vue"], resolve),
    name: "EditarUsuario",
    // meta: { can: ['SuperAdmin', 'Atendente'] } // <-- múltiplas permissões
  },
  {
    path: "/usuario/buscar",
    component: (resolve) =>
      require(["./app/Usuarios/BuscarUsuario.vue"], resolve),
    name: "BuscarUsuario",
    meta: { title: "Buscar" },
  },
  {
    path: "/usuarios/assinantes",
    component: (resolve) =>
      require(["./app/AssinaturasAdmin/Assinantes.vue"], resolve),
    name: "UsuariosAssinantes",
    meta: { title: "Usuários", can: ["SuperAdmin", "Admin", "Gestor", "Financeiro"] },
  },
  {
    path: "/usuarios/assinantes-armazenamento",
    component: (resolve) =>
      require(["./app/AssinaturasAdmin/AssinantesArmazenamento.vue"], resolve),
    name: "UsuariosAssinantesArmazenamento",
    meta: { title: "Usuários", can: ["SuperAdmin", "Admin", "Gestor", "Financeiro"] },
  },
  {
    path: "/pagamentos/pag=:page",
    component: (resolve) =>
      require(["./app/Financeiro/Pagamentos.vue"], resolve),
    name: "Pagamentos",
    meta: { title: "Pagamentos", can: ["SuperAdmin", "Admin", "Financeiro"] },
  },
  {
    path: "/monitoramento-pagamentos",
    component: (resolve) =>
      require(["./app/Financeiro/MonitoramentoPagamentos.vue"], resolve),
    name: "MonitoramentoPagamentos",
    meta: { title: "Logs de Pagamentos", can: ["SuperAdmin", "Admin", "Financeiro"] },
  },
  {
    path: "/relatorio-usuarios",
    component: (resolve) =>
      require(["./app/RelatorioUsuarios.vue"], resolve),
    name: "RelatorioUsuarios",
    meta: { title: "Relatório de Usuários" },
  },
  {
    path: "/pagamentos-em-aberto/pag=:page",
    component: (resolve) =>
      require(["./app/Financeiro/PagamentosEmAberto.vue"], resolve),
    name: "PagamentosEmAberto",
    meta: { title: "Pagamentos em Aberto" },
  },
  {
    path: "/cancelamentos/pag=:page",
    component: (resolve) =>
      require(["./app/Financeiro/Cancelamentos.vue"], resolve),
    name: "Cancelamentos",
    meta: { title: "Cancelamentos", can: ["SuperAdmin", "Admin", "Gestor", "Financeiro"] },
  },
  {
    path: "/onboarding-insights",
    component: (resolve) =>
      require(["./app/OnboardingInsights/Dashboard.vue"], resolve),
    name: "OnboardingInsights",
    meta: { title: "Onboarding", can: ["SuperAdmin", "Admin", "Gestor"] },
  },
  {
    path: "/contato-com-cliente/pag=:page",
    component: (resolve) =>
      require(["./app/Avisos/ContatoComCliente.vue"], resolve),
    name: "Contato",
    meta: { title: "Contato" },
  },
  {
    path: "/avisos",
    component: (resolve) => require(["./app/Avisos/Avisos.vue"], resolve),
    name: "Avisos",
    meta: { title: "Avisos", can: ["SuperAdmin", "Admin"] },
  },
  {
    path: "/testes",
    component: (resolve) => require(["./app/Testes/Testes.vue"], resolve),
    name: "Testes",
    meta: { title: "Materiais", can: ["SuperAdmin", "Admin"] },
  },
  {
    path: "/teste/:id",
    component: (resolve) => require(["./app/Testes/VerTeste.vue"], resolve),
    name: "VerTeste",
    meta: { title: "Ver Material", can: ["SuperAdmin", "Admin"] },
  },
  {
    path: "/teste/cadastrar",
    component: (resolve) => require(["./app/Testes/CriarTeste.vue"], resolve),
    name: "CriarTeste",
    meta: { title: "Cadastrar Material", can: ["SuperAdmin", "Admin"] },
  },
  {
    path: "/materiais/cadastro-automatico",
    component: (resolve) => require(["./app/Testes/CadastroAutomatico.vue"], resolve),
    name: "CriarMaterialAutomatico",
    meta: { title: "Cadastro Automático", can: ["SuperAdmin", "Admin"] },
  },
  {
    path: "/teste/:id/editar",
    component: (resolve) => require(["./app/Testes/EditarTeste.vue"], resolve),
    name: "EditarTeste",
    meta: { title: "Editar Material", can: ["SuperAdmin", "Admin"] },
  },
  {
    path: "/sem-permissao",
    component: (resolve) => require(["./app/SemPermissao.vue"], resolve),
    name: "SemPermissao",
  },
  {
    path: "/anamnese",
    component: (resolve) =>
      require(["./app/Documentos/Anamnese/Topicos.vue"], resolve),
    name: "Anamnese",
    meta: { title: "Anamnese", can: ["SuperAdmin", "Admin"] },
  },
  {
    path: "/informes/modelos",
    component: (resolve) =>
      require(["./app/Documentos/Informes/Modelos.vue"], resolve),
    name: "ModelosInformes",
    meta: { title: "Informes", can: ["SuperAdmin", "Admin"] },
  },
  {
    path: "/devolutivas/modelos",
    component: (resolve) =>
      require(["./app/Documentos/Devolutivas/Modelos.vue"], resolve),
    name: "ModelosDevolutivas",
    meta: { title: "Devolutivas", can: ["SuperAdmin", "Admin"] },
  },
  {
    path: "/encaminhamentos/modelos",
    component: (resolve) =>
      require(["./app/Documentos/Encaminhamentos/Modelos.vue"], resolve),
    name: "ModelosEncaminhamentos",
    meta: { title: "Encaminhamentos", can: ["SuperAdmin", "Admin"] },
  },
  {
    path: "/contratos/modelos",
    component: (resolve) =>
      require(["./app/Documentos/Contratos/Modelos.vue"], resolve),
    name: "ModelosContratos",
    meta: { title: "Contratos", can: ["SuperAdmin", "Admin"] },
  },
  {
    path: "/avaliacoes",
    component: (resolve) =>
      require(["./app/Documentos/Avaliacoes.vue"], resolve),
    name: "Avaliacoes",
    meta: { title: "Avaliações" },
  },
  {
    path: "/config-integracoes",
    component: (resolve) =>
      require([
        "./app/Configuracoes/Integracoes/ConfiguracoesLayout.vue",
      ], resolve),
    children: [
      {
        path: "",
        redirect: "/config-integracoes/deepseek",
        meta: { title: "Integrações" },
      },
      {
        path: "deepseek",
        component: (resolve) =>
          require([
            "./app/Configuracoes/Integracoes/DeepSeekConfig.vue",
          ], resolve),
        meta: { title: "Integrações" },
      },
      {
        path: "chatgpt",
        component: (resolve) =>
          require([
            "./app/Configuracoes/Integracoes/ChatGPTConfig.vue",
          ], resolve),
        meta: { title: "Integrações" },
      },
      {
        path: "mercado-pago",
        component: (resolve) =>
          require(["./app/Configuracoes/Integracoes/GatewayAssinaturaConfig.vue"], resolve),
        props: { gatewayDriver: "mercadopago", gatewayLabel: "Mercado Pago" },
        meta: { title: "Integrações", can: ["SuperAdmin", "Admin", "Gestor", "Financeiro"] },
      },
      {
        path: "asaas",
        component: (resolve) =>
          require(["./app/Configuracoes/Integracoes/GatewayAssinaturaConfig.vue"], resolve),
        props: { gatewayDriver: "asaas", gatewayLabel: "Asaas" },
        meta: { title: "Integrações", can: ["SuperAdmin", "Admin", "Gestor", "Financeiro"] },
      },
      {
        path: "pagbank",
        component: (resolve) =>
          require(["./app/Configuracoes/Integracoes/GatewayAssinaturaConfig.vue"], resolve),
        props: { gatewayDriver: "pagbank", gatewayLabel: "PagBank" },
        meta: { title: "Integrações", can: ["SuperAdmin", "Admin", "Gestor", "Financeiro"] },
      },
      {
        path: "pagbanck",
        redirect: "/config-integracoes/pagbank",
      },
      {
        path: "mercadopago",
        redirect: "/config-integracoes/mercado-pago",
      },
      {
        path: "mercado_pago",
        redirect: "/config-integracoes/mercado-pago",
      },
    ],
  },
  {
    path: "/configs",
    component: (resolve) =>
      require([
        "./app/Configuracoes/gerais/ConfigGeraisLayout.vue",
      ], resolve),
    children: [
      {
        path: "",
        redirect: "/configs/ficha-paciente",
        meta: { title: "Configurações Gerais" },
      },
      {
        path: "ficha-paciente",
        component: (resolve) =>
          require([
            "./app/Configuracoes/gerais/FichaPaciente.vue",
          ], resolve),
        meta: { title: "Configurações Gerais" },
      },
      {
        path: "modulo-ia",
        component: (resolve) =>
          require([
            "./app/Configuracoes/gerais/ModuloIA.vue",
          ], resolve),
        meta: { title: "Configurações Gerais" },
      }
    ],
  },
  {
    path: "/admin/relatorios-inteligentes",
    component: (resolve) =>
      require(["./app/RelatoriosInteligentesAdmin/Layout.vue"], resolve),
    meta: { title: "Relatórios Inteligentes", can: ["SuperAdmin", "Admin", "Gestor"] },
    children: [
      {
        path: "",
        redirect: "/admin/relatorios-inteligentes/dashboard",
      },
      {
        path: "dashboard",
        component: (resolve) =>
          require(["./app/RelatoriosInteligentesAdmin/Dashboard.vue"], resolve),
        meta: { title: "Relatórios Inteligentes", can: ["SuperAdmin", "Admin", "Gestor"] },
      },
      {
        path: "templates",
        component: (resolve) =>
          require(["./app/RelatoriosInteligentesAdmin/Templates.vue"], resolve),
        meta: { title: "Relatórios Inteligentes", can: ["SuperAdmin", "Admin", "Gestor"] },
      },
      {
        path: "prompts",
        component: (resolve) =>
          require(["./app/RelatoriosInteligentesAdmin/Prompts.vue"], resolve),
        meta: { title: "Relatórios Inteligentes", can: ["SuperAdmin", "Admin", "Gestor"] },
      },
      {
        path: "experimentos",
        component: (resolve) =>
          require(["./app/RelatoriosInteligentesAdmin/Experimentos.vue"], resolve),
        meta: { title: "Relatórios Inteligentes", can: ["SuperAdmin", "Admin", "Gestor"] },
      },
      {
        path: "qualidade",
        component: (resolve) =>
          require(["./app/RelatoriosInteligentesAdmin/Qualidade.vue"], resolve),
        meta: { title: "Relatórios Inteligentes", can: ["SuperAdmin", "Admin", "Gestor"] },
      },
      {
        path: "correcoes",
        component: (resolve) =>
          require(["./app/RelatoriosInteligentesAdmin/Correcoes.vue"], resolve),
        meta: { title: "Relatórios Inteligentes", can: ["SuperAdmin", "Admin", "Gestor"] },
      },
      {
        path: "auditoria",
        component: (resolve) =>
          require(["./app/RelatoriosInteligentesAdmin/Auditoria.vue"], resolve),
        meta: { title: "Relatórios Inteligentes", can: ["SuperAdmin", "Admin", "Gestor"] },
      },
    ],
  },
  {
    path: "/admin/assinaturas",
    component: (resolve) =>
      require(["./app/AssinaturasAdmin/Layout.vue"], resolve),
    meta: { title: "Formas de Pagamento", can: ["SuperAdmin", "Admin", "Gestor", "Financeiro"] },
    children: [
      {
        path: "",
        redirect: "/admin/assinaturas/formas-pagamento",
      },
      {
        path: "plataformas",
        component: (resolve) =>
          require(["./app/AssinaturasAdmin/Plataformas.vue"], resolve),
        meta: { title: "Formas de Pagamento", can: ["SuperAdmin", "Admin", "Gestor", "Financeiro"] },
      },
      {
        path: "credenciais",
        redirect: "/admin/assinaturas/configs",
      },
      {
        path: "configs",
        component: (resolve) =>
          require(["./app/AssinaturasAdmin/Configs.vue"], resolve),
        meta: { title: "Formas de Pagamento", can: ["SuperAdmin", "Admin", "Gestor", "Financeiro"] },
      },
      {
        path: "formas-pagamento",
        component: (resolve) =>
          require(["./app/AssinaturasAdmin/FormasPagamento.vue"], resolve),
        meta: { title: "Formas de Pagamento", can: ["SuperAdmin", "Admin", "Gestor", "Financeiro"] },
      },
      {
        path: "precos",
        component: (resolve) =>
          require(["./app/AssinaturasAdmin/PrecosArmazenamento.vue"], resolve),
        meta: { title: "Formas de Pagamento", can: ["SuperAdmin", "Admin", "Gestor", "Financeiro"] },
      },
      {
        path: "planos-gateway",
        component: (resolve) =>
          require(["./app/AssinaturasAdmin/PlanosGateway.vue"], resolve),
        meta: { title: "Formas de Pagamento", can: ["SuperAdmin", "Admin", "Gestor", "Financeiro"] },
      },
      {
        path: "pagbank-planos",
        component: (resolve) =>
          require(["./app/AssinaturasAdmin/PagbankPlanos.vue"], resolve),
        meta: { title: "Formas de Pagamento", can: ["SuperAdmin", "Admin", "Financeiro"] },
      },
      {
        path: "assinantes",
        redirect: "/usuarios/assinantes",
      },
      {
        path: "diagnostico",
        component: (resolve) =>
          require(["./app/AssinaturasAdmin/Diagnostico.vue"], resolve),
        meta: { title: "Formas de Pagamento", can: ["SuperAdmin", "Admin", "Gestor", "Financeiro"] },
      },
      {
        path: "auditoria",
        component: (resolve) =>
          require(["./app/AssinaturasAdmin/Auditoria.vue"], resolve),
        meta: { title: "Formas de Pagamento", can: ["SuperAdmin", "Admin", "Gestor", "Financeiro"] },
      },
    ],
  },
  {
    path: "/config-integracoes/assinaturas",
    redirect: "/admin/assinaturas/formas-pagamento",
  },
  {
    path: "/config-integracoes/assinaturas/:rest(.*)",
    redirect: (to) => `/admin/assinaturas/${to.params.rest || "formas-pagamento"}`,
  },
];

const router = new VueRouter({
  // mode: 'history',
  routes,
});

// Guard de permissão
router.beforeEach((to, from, next) => {
  const requiredPerm = to.meta.can;
  const user = window.Laravel.user; // seu usuário vem do backend

  if (!requiredPerm) {
    return next();
  }

  const required = Array.isArray(requiredPerm) ? requiredPerm : [requiredPerm];
  const hasPermission = user?.tipo_user?.some((role) =>
    required.includes(role)
  );

  if (hasPermission) {
    next();
  } else {
    next({ name: "SemPermissao" });
  }
});

export default router;
